<template>
  <div class="popup-wrapper" :class="device">
    <div class="card-holder">
      <div class="card" :class="classList">
        <slot></slot>
      </div>
      <div class="overlay" @click="close"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Popup',
  props: {
    title: {
      type: String,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('codd_close');
    },
  },
  computed: {
    ...mapGetters({
      device: 'getDevice',
    }),

    classList() {
      let classes = {};
      if (this.size) {
        classes[this.size] = true;
      }
      if (this.device === 'mobile') {
        classes['mobile'] = true;
      }
      if (this.tooltip) {
        classes['tooltip'] = true;
      }
      return classes;
    },
  },
};
</script>

<style lang="scss">
.popup-wrapper {
  position: relative;
  z-index: 1000;

  .card-holder {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;

    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .card {
    position: relative;
    z-index: 1000;
    max-height: 90vh;
    overflow-y: auto;

    &.medium {
      width: 50%;
      max-height: 70vh;
      max-width: 800px;
      min-height: 255px;

      @media only screen and (min-width: 768px) {
        max-height: 90vh;
      }
    }

    &.large {
      width: 90%;
      height: auto;
    }

    &.tooltip {
      width: auto !important;
      min-width: 400px;
      max-width: calc(100vw - 50px);

      iframe {
        max-width: 100%;
      }
    }

    &.mobile {
      min-width: 90%;
    }
  }

  .overlay {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }
}

</style>
